class StatCard {
  constructor(el) {
    this.el = el;
    this.setElWidthCustomProperty();

    this.debouncer = null;
    window.addEventListener('resize', () => {
      clearTimeout(this.debouncer);
      this.debouncer = setTimeout(() => {
        this.setElWidthCustomProperty();
      }, 150);
    });

    // For the editor, just ensure it get's the width set on load
    if( window.acf ) {
      setTimeout(() => {
        this.setElWidthCustomProperty();
      }, 2000);
    }
  }

  setElWidthCustomProperty() {
    const elWidth = this.el.offsetWidth;
    this.el.style.setProperty('--card-width', `${elWidth}px`);

    // If it's wider than 400px, add a .wide class, otherwise remove it if it's present
    if(elWidth > 400){
      this.el.classList.add('wide');
    } else if(this.el.classList.contains('wide')) {
      this.el.classList.remove('wide');
    }
  }
}

export const InitStatCard = () => {
  const els = document.querySelectorAll('.stat_card');
  els.forEach(el => {
    new StatCard(el);
  });
}

// Initialize the statistic card in the editor
export const InitStatCardEditor = () => {
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=statistic-card', ( $block ) => {
      const statCard = $block[0].querySelector('.stat_card');
      if(!statCard) return;
      statCard.instance = new StatCard(statCard);
    });
  }
}